import { ApolloClient, InMemoryCache } from '@apollo/client'
import { LOCAL, DEVELOP } from 'constants/env'

export const apolloClient = new ApolloClient({
  uri: process.env.REACT_APP_ENV === 'local' ? LOCAL.URL : DEVELOP.URL,
  cache: new InMemoryCache(),
})
